import { useTranslation } from 'react-i18next'

import { CalendarIcon } from '@mercai/clever'

import { formatDate, textToSnakeCase } from '@/helpers'

import { InfoList, InfoListListProps } from '@/components'

import type { OrderLogisticStatusHistoryProps } from './order-logistic-status-history.type'

export const OrderLogisticStatusHistory = ({
  shipmentStatusHistory,
  isLoading,
}: OrderLogisticStatusHistoryProps) => {
  const { t } = useTranslation('componentOrderCenterShow')
  const { t: tEnums } = useTranslation('enums')

  const mountStatus = () => {
    const statusList: InfoListListProps[] = []

    if (shipmentStatusHistory) {
      Object.keys(shipmentStatusHistory)?.forEach((status) => {
        statusList.push({
          label: tEnums(`logistic_shipment_status_${textToSnakeCase(status)}`),
          value: formatDate(shipmentStatusHistory[status]),
        })
      })
    }

    return statusList
  }

  const list = mountStatus()

  return (
    <div>
      <InfoList
        isLoading={isLoading}
        iconTitle={<CalendarIcon />}
        title={t('orderLogisticShipmentStatusHistoryTitle')}
        list={list}
      />
    </div>
  )
}
